import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getCurrentCompany } from '../../actions/companyActions';
import { getInfosByPage } from '../../actions/infoActions';
import Banner from '../common/Banner';
import TextField from '../common/TextField';
import SelectList from '../common/SelectList';
import SelectListProduct from '../common/SelectListProduct';
import options from '../common/Options';
import { createProduct } from '../../actions/productActions';
import SideNavbar from '../layout/SideNavbar';
import Navbar from '../layout/Navbar';
import { FormattedMessage, injectIntl } from 'react-intl';
import Cleave from 'cleave.js/react';
import classnames from 'classnames';
import Spinner from '../common/Spinner';
import isEmpty from '../../validation/is-empty';
import ReactQuill from 'react-quill';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import MomentLocaleUtils, {
  formatDate,
  parseDate,
} from 'react-day-picker/moment';
import ReactTooltip from 'react-tooltip';
import 'moment/locale/fi';

class CreateProduct extends Component {
  constructor(props) {
    super(props);
    this.state = {
      company: '',
      productType: '',
      category: '',
      buylink: '',
      titleFi: '',
      titleEn: '',
      labelFi: '',
      labelEn: '',
      languagesFi: '',
      languagesEn: '',
      outfitFi: '',
      outfitEn: '',
      priceFi: '',
      priceEn: '',
      placeFi: '',
      placeEn: '',
      descriptionFi: '',
      descriptionEn: '',
      displayContacts: true,
      phone: '',
      email: '',
      address: '',
      website: '',
      photo: null,
      uploadMessage: '',
      formSubmit: false,
      errors: {},
    };

    this.onEditorChange = this.onEditorChange.bind(this);
    this.onEditorChangeEn = this.onEditorChangeEn.bind(this);
    this.onStartDayChange = this.onStartDayChange.bind(this);
    this.onEndDayChange = this.onEndDayChange.bind(this);
  }
  static getDerivedStateFromProps(props, state) {
    if (props.errors !== state.errors) {
      return { errors: props.errors, formSubmit: false };
    }
    return null;
  }

  componentDidMount() {
    document.title = this.props.intl.formatMessage({
      id: 'createproduct.title',
    });
    this.props.getCurrentCompany();
    this.props.getInfosByPage('product');
  }

  onFileSelect = (event) => {
    this.setState({
      photo: event.target.files[0],
      uploadMessage: event.target.value.replace('C:\\fakepath\\', ''),
    });
  };

  onEditorChange(value) {
    this.setState({ descriptionFi: value });
  }

  onEditorChangeEn(value) {
    this.setState({ descriptionEn: value });
  }

  onStartDayChange(selectedDay) {
    this.setState({
      startdate: selectedDay,
    });
  }

  onEndDayChange(selectedDay) {
    this.setState({
      enddate: selectedDay,
    });
  }

  onChange = (e) => this.setState({ [e.target.name]: e.target.value });

  onClick = (e) => {
    e.preventDefault();
    this.setState({ formSubmit: true }, () => {
      this.onSubmit();
    });
  };

  onSubmit() {
    let website;

    this.state.website === 'https://'
      ? (website = '')
      : (website = this.state.website);

    let buylink;

    this.state.buylink === 'https://'
      ? (buylink = '')
      : (buylink = this.state.buylink);

    const productData = new FormData();
    productData.append('company', this.state.company);
    productData.append('productType', this.state.productType);
    productData.append('category', this.state.productType === 'Accommodation' ? 'Accommodation, travelling, and equipment rental' : this.state.category);
    productData.append('buylink', buylink);
    productData.append('photo', this.state.photo);
    productData.append('titleFi', this.state.titleFi);
    productData.append('titleEn', this.state.titleEn);
    productData.append('languagesFi', this.state.languagesFi);
    productData.append('languagesEn', this.state.languagesEn);
    productData.append('labelFi', this.state.labelFi);
    productData.append('labelEn', this.state.labelEn);
    productData.append('outfitFi', this.state.outfitFi);
    productData.append('outfitEn', this.state.outfitEn);
    productData.append('priceFi', this.state.priceFi);
    productData.append('priceEn', this.state.priceEn);
    productData.append('placeFi', this.state.placeFi);
    productData.append('placeEn', this.state.placeEn);
    productData.append('descriptionFi', this.state.descriptionFi);
    productData.append('descriptionEn', this.state.descriptionEn);
    productData.append('duration', this.state.duration);
    productData.append('groupsize', this.state.groupsize);
    productData.append('startdate', this.state.startdate);
    productData.append('enddate', this.state.enddate);
    productData.append('contacts', this.state.displayContacts);
    productData.append('phone', this.state.phone);
    productData.append('email', this.state.email);
    productData.append('address', this.state.address);
    productData.append('website', website);

    productData.append('locale', this.props.locale.lang);

    this.props.createProduct(productData, this.props.history);
  }

  render() {
    const { errors, uploadMessage } = this.state;
    const { company, loading } = this.props.company;
    const FORMAT = 'LL';
    let companiesOptions;

    if (company === null || loading || this.props.info.loading) {
      companiesOptions = <Spinner />;
    } else {
      if (Object.keys(company).length > 0) {
        const selectOptions = company.map((option) => (
          <option key={option._id} value={option._id}>
            {option.name}
          </option>
        ));
        companiesOptions = (
          <div>
            <ReactTooltip place="right" multiline={true} />
            <div className="col-lg-8 offset-lg-2">
              <div className="form-group">
                <label>
                  <FormattedMessage id="createproduct.company" />
                  <span className="text-danger">&nbsp;*</span>
                  {!isEmpty(
                    this.props.info.infos.find(
                      (item) =>
                        'company' === item.name &&
                        this.props.locale.lang === item.lang
                    )
                  ) && (
                      <img
                        src="img/information.png"
                        className="info"
                        alt=""
                        data-tip={
                          this.props.info.infos.find(
                            (item) =>
                              'company' === item.name &&
                              this.props.locale.lang === item.lang
                          ).text
                        }
                      />
                    )}
                </label>
                <select
                  className={classnames('form-control classic', {
                    'is-invalid': errors.company,
                  })}
                  name="company"
                  value={this.state.company}
                  onChange={this.onChange}
                >
                  <FormattedMessage id="createproduct.selectCompany">
                    {(company) => (
                      <option key={company} value="">
                        {company}
                      </option>
                    )}
                  </FormattedMessage>
                  {selectOptions}
                </select>
                {errors.company && (
                  <div className="invalid-feedback">{errors.company}</div>
                )}
              </div>
            </div>
            <div className="col-lg-8 offset-lg-2">
              <FormattedMessage id="createproduct.productType">
                {(productType) => (
                  <SelectListProduct
                    name="productType"
                    value={this.state.productType}
                    onChange={this.onChange}
                    error={errors.productType}
                    label={productType}
                    required={true}
                    info={this.props.info}
                    locale={this.props.locale}
                  />
                )}
              </FormattedMessage>
            </div>
          </div>
        );
      } else {
        companiesOptions = (
          <div>
            <div className="text-center">
              <h5>
                <FormattedMessage id="createproduct.noCompanies" />
              </h5>
            </div>
          </div>
        );
      }
    }

    return (
      <div>
        <Navbar />
        <FormattedMessage id="createproduct.addnewproduct">
          {(addnewproduct) => <Banner pageName={addnewproduct} />}
        </FormattedMessage>
        <section className="user-page section-padding">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 col-md-5 col-xs-12">
                <SideNavbar />
              </div>
              <div className="col-lg-8 col-md-7 col-xs-12">
                <div className="my-address">
                  <h3 className="heading">
                    <FormattedMessage id="createproduct.addnewproduct" />
                  </h3>
                  <div className="section-inforamation">
                    <form>
                      {companiesOptions}
                      {!(
                        isEmpty(company) ||
                        isEmpty(this.state.productType) ||
                        this.state.productType === '0' ||
                        loading ||
                        this.props.info.loading
                      ) && (
                          <div className="row">
                            <ReactTooltip place="right" multiline={true} />
                            <div className="col-sm-6">
                              <FormattedMessage id="createproduct.titlefi">
                                {(titleFi) => (
                                  <FormattedMessage id="createproduct.entertitlefi">
                                    {(EnterYourTitleFi) => (
                                      <TextField
                                        label={titleFi}
                                        placeholder={EnterYourTitleFi}
                                        name="titleFi"
                                        type="text"
                                        value={this.state.titleFi}
                                        onChange={this.onChange}
                                        error={errors.titleFi}
                                        required={true}
                                        info={this.props.info}
                                        locale={this.props.locale}
                                      />
                                    )}
                                  </FormattedMessage>
                                )}
                              </FormattedMessage>
                            </div>
                            <div className="col-sm-6">
                              <FormattedMessage id="createproduct.titleen">
                                {(titleEn) => (
                                  <FormattedMessage id="createproduct.entertitleen">
                                    {(EnterYourTitleEn) => (
                                      <TextField
                                        label={titleEn}
                                        placeholder={EnterYourTitleEn}
                                        name="titleEn"
                                        type="text"
                                        value={this.state.titleEn}
                                        onChange={this.onChange}
                                        error={errors.titleEn}
                                        info={this.props.info}
                                        locale={this.props.locale}
                                      />
                                    )}
                                  </FormattedMessage>
                                )}
                              </FormattedMessage>
                            </div>
                            <div className="col-sm-6">
                              <FormattedMessage id="createcompany.category">
                                {(category) => (
                                  <SelectList
                                    name="category"
                                    value={this.state.category}
                                    onChange={this.onChange}
                                    option={options}
                                    error={errors.category}
                                    label={category}
                                    required={true}
                                    info={this.props.info}
                                    locale={this.props.locale}
                                    selected={this.state.productType}
                                  />
                                )}
                              </FormattedMessage>
                            </div>
                            <div className="col-sm-6">
                              <FormattedMessage id="createproduct.buylink">
                                {(buylink) => (
                                  <FormattedMessage id="createproduct.enterbuylink">
                                    {(enterbuylink) => (
                                      <div className="form-group">
                                        <label>
                                          {buylink}
                                          {!isEmpty(
                                            this.props.info.infos.find(
                                              (item) =>
                                                'buylink' === item.name &&
                                                this.props.locale.lang ===
                                                item.lang
                                            )
                                          ) && (
                                              <img
                                                src="img/information.png"
                                                className="info"
                                                alt=""
                                                data-tip={
                                                  this.props.info.infos.find(
                                                    (item) =>
                                                      'buylink' === item.name &&
                                                      this.props.locale.lang ===
                                                      item.lang
                                                  ).text
                                                }
                                              />
                                            )}
                                        </label>
                                        <Cleave
                                          className={classnames('form-control', {
                                            'is-invalid': errors.buylink,
                                          })}
                                          options={{
                                            prefix: 'https://',
                                            lowercase: true,
                                          }}
                                          placeholder={enterbuylink}
                                          name="buylink"
                                          value={this.state.buylink}
                                          onChange={this.onChange}
                                        />
                                        {errors.buylink && (
                                          <div className="invalid-feedback">
                                            {errors.buylink}
                                          </div>
                                        )}
                                      </div>
                                    )}
                                  </FormattedMessage>
                                )}
                              </FormattedMessage>
                            </div>
                            <div className="col-sm-6">
                              <FormattedMessage id="createproduct.labelfi">
                                {(labelFi) => (
                                  <FormattedMessage id="createproduct.enterlabelfi">
                                    {(EnterYourLabelFi) => (
                                      <TextField
                                        label={labelFi}
                                        placeholder={EnterYourLabelFi}
                                        name="labelFi"
                                        type="text"
                                        value={this.state.labelFi}
                                        onChange={this.onChange}
                                        error={errors.labelFi}
                                        info={this.props.info}
                                        locale={this.props.locale}
                                      />
                                    )}
                                  </FormattedMessage>
                                )}
                              </FormattedMessage>
                            </div>
                            <div className="col-sm-6">
                              <FormattedMessage id="createproduct.labelen">
                                {(labelEn) => (
                                  <FormattedMessage id="createproduct.enterlabelen">
                                    {(EnterYourLabelEn) => (
                                      <TextField
                                        label={labelEn}
                                        placeholder={EnterYourLabelEn}
                                        name="labelEn"
                                        type="text"
                                        value={this.state.labelEn}
                                        onChange={this.onChange}
                                        error={errors.labelEn}
                                        info={this.props.info}
                                        locale={this.props.locale}
                                      />
                                    )}
                                  </FormattedMessage>
                                )}
                              </FormattedMessage>
                            </div>
                            {this.state.productType !== 'Product' && (
                              <div className="col-sm-6">
                                <FormattedMessage id="createproduct.languagesfi">
                                  {(languagesFi) => (
                                    <FormattedMessage id="createproduct.enterlanguagesfi">
                                      {(EnterLanguagesFi) => (
                                        <TextField
                                          label={languagesFi}
                                          placeholder={EnterLanguagesFi}
                                          name="languagesFi"
                                          type="text"
                                          value={this.state.languagesFi}
                                          onChange={this.onChange}
                                          error={errors.languagesFi}
                                          info={this.props.info}
                                          locale={this.props.locale}
                                        />
                                      )}
                                    </FormattedMessage>
                                  )}
                                </FormattedMessage>
                              </div>
                            )}
                            {this.state.productType !== 'Product' && (
                              <div className="col-sm-6">
                                <FormattedMessage id="createproduct.languagesen">
                                  {(languagesEn) => (
                                    <FormattedMessage id="createproduct.enterlanguagesen">
                                      {(EnterLanguagesEn) => (
                                        <TextField
                                          label={languagesEn}
                                          placeholder={EnterLanguagesEn}
                                          name="languagesEn"
                                          type="text"
                                          value={this.state.languagesEn}
                                          onChange={this.onChange}
                                          error={errors.languagesEn}
                                          info={this.props.info}
                                          locale={this.props.locale}
                                        />
                                      )}
                                    </FormattedMessage>
                                  )}
                                </FormattedMessage>
                              </div>
                            )}
                            {this.state.productType === 'Service' && (
                              <div className="col-sm-6">
                                <FormattedMessage id="createproduct.outfitfi">
                                  {(outfitFi) => (
                                    <FormattedMessage id="createproduct.enteroutfitfi">
                                      {(EnterOutfitFi) => (
                                        <TextField
                                          label={outfitFi}
                                          placeholder={EnterOutfitFi}
                                          name="outfitFi"
                                          type="text"
                                          value={this.state.outfitFi}
                                          onChange={this.onChange}
                                          error={errors.outfitFi}
                                          info={this.props.info}
                                          locale={this.props.locale}
                                        />
                                      )}
                                    </FormattedMessage>
                                  )}
                                </FormattedMessage>
                              </div>
                            )}
                            {this.state.productType === 'Service' && (
                              <div className="col-sm-6">
                                <FormattedMessage id="createproduct.outfiten">
                                  {(outfitEn) => (
                                    <FormattedMessage id="createproduct.enteroutfiten">
                                      {(EnterOutfitEn) => (
                                        <TextField
                                          label={outfitEn}
                                          placeholder={EnterOutfitEn}
                                          name="outfitEn"
                                          type="text"
                                          value={this.state.outfitEn}
                                          onChange={this.onChange}
                                          error={errors.outfitEn}
                                          info={this.props.info}
                                          locale={this.props.locale}
                                        />
                                      )}
                                    </FormattedMessage>
                                  )}
                                </FormattedMessage>
                              </div>
                            )}
                            {this.state.productType === 'Service' && (
                              <div className="col-sm-6">
                                <FormattedMessage id="createproduct.duration">
                                  {(duration) => (
                                    <FormattedMessage id="createproduct.enterduration">
                                      {(EnterDuration) => (
                                        <TextField
                                          label={duration}
                                          placeholder={EnterDuration}
                                          name="duration"
                                          type="number"
                                          value={this.state.duration}
                                          onChange={this.onChange}
                                          error={errors.duration}
                                          info={this.props.info}
                                          locale={this.props.locale}
                                        />
                                      )}
                                    </FormattedMessage>
                                  )}
                                </FormattedMessage>
                              </div>
                            )}
                            {this.state.productType !== 'Product' && (
                              <div className="col-sm-6">
                                <FormattedMessage id="createproduct.groupsize">
                                  {(groupsize) => (
                                    <FormattedMessage id="createproduct.entergroupsize">
                                      {(EnterGroupSize) => (
                                        <TextField
                                          label={groupsize}
                                          placeholder={EnterGroupSize}
                                          name="groupsize"
                                          type="number"
                                          value={this.state.groupsize}
                                          onChange={this.onChange}
                                          error={errors.groupsize}
                                          info={this.props.info}
                                          locale={this.props.locale}
                                        />
                                      )}
                                    </FormattedMessage>
                                  )}
                                </FormattedMessage>
                              </div>
                            )}
                            <div className="col-sm-6">
                              <FormattedMessage id="createproduct.pricefi">
                                {(priceFi) => (
                                  <FormattedMessage id="createproduct.enterpricefi">
                                    {(EnterYourPriceFi) => (
                                      <TextField
                                        label={priceFi}
                                        placeholder={EnterYourPriceFi}
                                        name="priceFi"
                                        type="text"
                                        value={this.state.priceFi}
                                        onChange={this.onChange}
                                        error={errors.priceFi}
                                        info={this.props.info}
                                        locale={this.props.locale}
                                      />
                                    )}
                                  </FormattedMessage>
                                )}
                              </FormattedMessage>
                            </div>
                            <div className="col-sm-6">
                              <FormattedMessage id="createproduct.priceen">
                                {(priceEn) => (
                                  <FormattedMessage id="createproduct.enterpriceen">
                                    {(EnterYourPriceEn) => (
                                      <TextField
                                        label={priceEn}
                                        placeholder={EnterYourPriceEn}
                                        name="priceEn"
                                        type="text"
                                        value={this.state.priceEn}
                                        onChange={this.onChange}
                                        error={errors.priceEn}
                                        info={this.props.info}
                                        locale={this.props.locale}
                                      />
                                    )}
                                  </FormattedMessage>
                                )}
                              </FormattedMessage>
                            </div>
                            {this.state.productType !== 'Product' && (
                              <div className="col-sm-6">
                                <FormattedMessage id="createproduct.placefi">
                                  {(placeFi) => (
                                    <FormattedMessage id="createproduct.enterplacefi">
                                      {(EnterPlaceFi) => (
                                        <TextField
                                          label={placeFi}
                                          placeholder={EnterPlaceFi}
                                          name="placeFi"
                                          type="text"
                                          value={this.state.placeFi}
                                          onChange={this.onChange}
                                          error={errors.placeFi}
                                          info={this.props.info}
                                          locale={this.props.locale}
                                        />
                                      )}
                                    </FormattedMessage>
                                  )}
                                </FormattedMessage>
                              </div>
                            )}
                            {this.state.productType !== 'Product' && (
                              <div className="col-sm-6">
                                <FormattedMessage id="createproduct.placeen">
                                  {(placeEn) => (
                                    <FormattedMessage id="createproduct.enterplaceen">
                                      {(EnterPlaceEn) => (
                                        <TextField
                                          label={placeEn}
                                          placeholder={EnterPlaceEn}
                                          name="placeEn"
                                          type="text"
                                          value={this.state.placeEn}
                                          onChange={this.onChange}
                                          error={errors.placeEn}
                                          info={this.props.info}
                                          locale={this.props.locale}
                                        />
                                      )}
                                    </FormattedMessage>
                                  )}
                                </FormattedMessage>
                              </div>
                            )}
                            {this.state.productType !== 'Product' && (
                              <div className="col-sm-6">
                                <FormattedMessage id="createproduct.startdate">
                                  {(priceEn) => (
                                    <FormattedMessage id="createproduct.enterstartdate">
                                      {(EnterEndDate) => (
                                        <div className="form-group">
                                          <label>
                                            {priceEn}{' '}
                                            {!isEmpty(
                                              this.props.info.infos.find(
                                                (item) =>
                                                  'startdate' === item.name &&
                                                  this.props.locale.lang ===
                                                  item.lang
                                              )
                                            ) && (
                                                <img
                                                  src="img/information.png"
                                                  className="info"
                                                  alt=""
                                                  data-tip={
                                                    this.props.info.infos.find(
                                                      (item) =>
                                                        'startdate' === item.name &&
                                                        this.props.locale.lang ===
                                                        item.lang
                                                    ).text
                                                  }
                                                />
                                              )}
                                          </label>
                                          <DayPickerInput
                                            onDayChange={this.onStartDayChange}
                                            value={this.state.startdate}
                                            formatDate={formatDate}
                                            format={FORMAT}
                                            parseDate={parseDate}
                                            placeholder={`${formatDate(
                                              new Date(),
                                              FORMAT,
                                              this.props.locale.lang
                                            )}`}
                                            dayPickerProps={{
                                              selectedDays: this.state.startdate,
                                              locale: this.props.locale.lang,
                                              localeUtils: MomentLocaleUtils,
                                            }}
                                          />
                                        </div>
                                      )}
                                    </FormattedMessage>
                                  )}
                                </FormattedMessage>
                              </div>
                            )}
                            {this.state.productType !== 'Product' && (
                              <div className="col-sm-6">
                                <FormattedMessage id="createproduct.enddate">
                                  {(priceEn) => (
                                    <FormattedMessage id="createproduct.enterenddate">
                                      {(EnterEndDate) => (
                                        <div className="form-group">
                                          <label>
                                            {priceEn}
                                            {!isEmpty(
                                              this.props.info.infos.find(
                                                (item) =>
                                                  'enddate' === item.name &&
                                                  this.props.locale.lang ===
                                                  item.lang
                                              )
                                            ) && (
                                                <img
                                                  src="img/information.png"
                                                  className="info"
                                                  alt=""
                                                  data-tip={
                                                    this.props.info.infos.find(
                                                      (item) =>
                                                        'enddate' === item.name &&
                                                        this.props.locale.lang ===
                                                        item.lang
                                                    ).text
                                                  }
                                                />
                                              )}
                                          </label>
                                          <DayPickerInput
                                            onDayChange={this.onEndDayChange}
                                            value={this.state.enddate}
                                            formatDate={formatDate}
                                            format={FORMAT}
                                            parseDate={parseDate}
                                            placeholder={`${formatDate(
                                              new Date(),
                                              FORMAT,
                                              this.props.locale.lang
                                            )}`}
                                            dayPickerProps={{
                                              selectedDays: this.state.enddate,
                                              locale: this.props.locale.lang,
                                              localeUtils: MomentLocaleUtils,
                                            }}
                                          />
                                        </div>
                                      )}
                                    </FormattedMessage>
                                  )}
                                </FormattedMessage>
                              </div>
                            )}
                            <div className="col-lg-12">
                              <FormattedMessage id="createproduct.descriptionfi">
                                {(descriptionFi) => (
                                  <FormattedMessage id="createproduct.enterdescriptionfi">
                                    {(EnterDescriptionFi) => (
                                      <div>
                                        <label>
                                          {descriptionFi}
                                          <span className="text-danger">
                                            &nbsp;*
                                        </span>
                                          {!isEmpty(
                                            this.props.info.infos.find(
                                              (item) =>
                                                'descriptionFi' === item.name &&
                                                this.props.locale.lang ===
                                                item.lang
                                            )
                                          ) && (
                                              <img
                                                src="img/information.png"
                                                className="info"
                                                alt=""
                                                data-tip={
                                                  this.props.info.infos.find(
                                                    (item) =>
                                                      'descriptionFi' ===
                                                      item.name &&
                                                      this.props.locale.lang ===
                                                      item.lang
                                                  ).text
                                                }
                                              />
                                            )}
                                        </label>
                                        <div
                                          className={classnames('editor', {
                                            'is-invalid': errors.descriptionFi,
                                          })}
                                        >
                                          <ReactQuill
                                            value={this.state.descriptionFi}
                                            onChange={this.onEditorChange}
                                            modules={CreateProduct.modules}
                                            formats={CreateProduct.formats}
                                            placeholder={EnterDescriptionFi}
                                          />
                                          {errors.description && (
                                            <div className="invalid-feedback">
                                              {errors.description}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </FormattedMessage>
                                )}
                              </FormattedMessage>
                            </div>
                            <div className="col-lg-12">
                              <FormattedMessage id="createproduct.descriptionen">
                                {(descriptionEn) => (
                                  <FormattedMessage id="createproduct.enterdescriptionen">
                                    {(EnterDescriptionEn) => (
                                      <div>
                                        <label>
                                          {descriptionEn}
                                          <span className="text-danger">
                                            &nbsp;*
                                        </span>
                                          {!isEmpty(
                                            this.props.info.infos.find(
                                              (item) =>
                                                'descriptionEn' === item.name &&
                                                this.props.locale.lang ===
                                                item.lang
                                            )
                                          ) && (
                                              <img
                                                src="img/information.png"
                                                className="info"
                                                alt=""
                                                data-tip={
                                                  this.props.info.infos.find(
                                                    (item) =>
                                                      'descriptionEn' ===
                                                      item.name &&
                                                      this.props.locale.lang ===
                                                      item.lang
                                                  ).text
                                                }
                                              />
                                            )}
                                        </label>
                                        <div
                                          className={classnames('editor', {
                                            'is-invalid': errors.descriptionEn,
                                          })}
                                        >
                                          <ReactQuill
                                            value={this.state.descriptionEn}
                                            onChange={this.onEditorChangeEn}
                                            modules={CreateProduct.modules}
                                            formats={CreateProduct.formats}
                                            placeholder={EnterDescriptionEn}
                                          />
                                          {errors.description && (
                                            <div className="invalid-feedback">
                                              {errors.description}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </FormattedMessage>
                                )}
                              </FormattedMessage>
                            </div>
                            <div className="col-lg-12 mb-4">
                              <label>
                                <FormattedMessage id="createproduct.photo" />
                                <span className="text-danger">&nbsp;*</span>
                                {!isEmpty(
                                  this.props.info.infos.find(
                                    (item) =>
                                      'photo' === item.name &&
                                      this.props.locale.lang === item.lang
                                  )
                                ) && (
                                    <img
                                      src="img/information.png"
                                      className="info"
                                      alt=""
                                      data-tip={
                                        this.props.info.infos.find(
                                          (item) =>
                                            'photo' === item.name &&
                                            this.props.locale.lang === item.lang
                                        ).text
                                      }
                                    />
                                  )}
                              </label>
                              <div className="custom-file">
                                <input
                                  type="file"
                                  className="custom-file-input"
                                  id="customFile"
                                  onChange={this.onFileSelect}
                                  ref={(ref) => (this.fileUpload = ref)}
                                />
                                <label
                                  className="custom-file-label"
                                  htmlFor="customFile"
                                >
                                  {uploadMessage ? (
                                    uploadMessage
                                  ) : (
                                      <FormattedMessage id="createcompany.Uploadyourimage" />
                                    )}
                                </label>
                                <label>
                                  <FormattedMessage id="createproduct.optimalsize" />
                                </label>
                              </div>
                              {errors.url && (
                                <div className="is-invalid">
                                  <div className="invalid-feedback">
                                    {errors.url}
                                  </div>
                                </div>
                              )}
                            </div>
                            <div className="col-lg-12 mt-4 mb-4">
                              <div className="row">
                                <div className="col-5 offset-3">
                                  <h3 className="settings-title">
                                    <FormattedMessage id="createproduct.usecompanyscontacts" />
                                  </h3>
                                </div>
                                <div className="col-2">
                                  <div className="settings">
                                    <input
                                      name="displayContacts"
                                      type="checkbox"
                                      checked={this.state.displayContacts}
                                      onChange={() => {
                                        this.setState((prevState) => ({
                                          displayContacts: !prevState.displayContacts,
                                        }));
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            {!this.state.displayContacts && (
                              <div className="col-sm-6">
                                <FormattedMessage id="createproduct.PhoneNumber">
                                  {(PhoneNumber) => (
                                    <FormattedMessage id="createproduct.PhoneNumberExample">
                                      {(PhoneNumberExample) => (
                                        <div className="form-group">
                                          <label>
                                            {PhoneNumber}
                                            {!isEmpty(
                                              this.props.info.infos.find(
                                                (item) =>
                                                  'phone' === item.name &&
                                                  this.props.locale.lang ===
                                                  item.lang
                                              )
                                            ) && (
                                                <img
                                                  src="img/information.png"
                                                  className="info"
                                                  alt=""
                                                  data-tip={
                                                    this.props.info.infos.find(
                                                      (item) =>
                                                        'phone' === item.name &&
                                                        this.props.locale.lang ===
                                                        item.lang
                                                    ).text
                                                  }
                                                />
                                              )}
                                          </label>
                                          <Cleave
                                            className={classnames(
                                              'form-control',
                                              {
                                                'is-invalid': errors.phone,
                                              }
                                            )}
                                            options={{
                                              delimiter: ' ',
                                              blocks: [3, 3, 5],
                                              numericOnly: true,
                                            }}
                                            placeholder={PhoneNumberExample}
                                            name="phone"
                                            value={this.state.phone}
                                            onChange={this.onChange}
                                          />
                                          {errors.phone && (
                                            <div className="invalid-feedback">
                                              {errors.phone}
                                            </div>
                                          )}
                                        </div>
                                      )}
                                    </FormattedMessage>
                                  )}
                                </FormattedMessage>
                                <ReactTooltip place="right" multiline={true} />
                              </div>
                            )}
                            {!this.state.displayContacts && (
                              <div className="col-sm-6">
                                <FormattedMessage id="createproduct.EmailAddress">
                                  {(EmailAddress) => (
                                    <FormattedMessage id="createproduct.EmailAddressExample">
                                      {(EmailAddressExample) => (
                                        <TextField
                                          label={EmailAddress}
                                          placeholder={EmailAddressExample}
                                          name="email"
                                          type="email"
                                          value={this.state.email}
                                          onChange={this.onChange}
                                          error={errors.email}
                                          info={this.props.info}
                                          locale={this.props.locale}
                                        />
                                      )}
                                    </FormattedMessage>
                                  )}
                                </FormattedMessage>
                                <ReactTooltip place="right" multiline={true} />
                              </div>
                            )}
                            {!this.state.displayContacts && (
                              <div className="col-sm-6">
                                <FormattedMessage id="createproduct.CompanyAddress">
                                  {(CompanyAddress) => (
                                    <FormattedMessage id="createproduct.EnterYourCompanyAddress">
                                      {(EnterYourCompanyAddress) => (
                                        <TextField
                                          label={CompanyAddress}
                                          placeholder={EnterYourCompanyAddress}
                                          name="address"
                                          type="text"
                                          value={this.state.address}
                                          onChange={this.onChange}
                                          error={errors.address}
                                          info={this.props.info}
                                          locale={this.props.locale}
                                        />
                                      )}
                                    </FormattedMessage>
                                  )}
                                </FormattedMessage>
                                <ReactTooltip place="right" multiline={true} />
                              </div>
                            )}
                            {!this.state.displayContacts && (
                              <div className="col-sm-6">
                                <FormattedMessage id="createproduct.CompanyWebsite">
                                  {(CompanyWebsite) => (
                                    <FormattedMessage id="createproduct.EnterYourCompanyWebsite">
                                      {(EnterYourCompanyWebsite) => (
                                        <div className="form-group">
                                          <label>
                                            {CompanyWebsite}
                                            {!isEmpty(
                                              this.props.info.infos.find(
                                                (item) =>
                                                  'website' === item.name &&
                                                  this.props.locale.lang ===
                                                  item.lang
                                              )
                                            ) && (
                                                <img
                                                  src="img/information.png"
                                                  className="info"
                                                  alt=""
                                                  data-tip={
                                                    this.props.info.infos.find(
                                                      (item) =>
                                                        'website' === item.name &&
                                                        this.props.locale.lang ===
                                                        item.lang
                                                    ).text
                                                  }
                                                />
                                              )}
                                          </label>
                                          <Cleave
                                            className={classnames(
                                              'form-control',
                                              {
                                                'is-invalid': errors.website,
                                              }
                                            )}
                                            options={{
                                              prefix: 'https://',
                                              lowercase: true,
                                            }}
                                            placeholder={EnterYourCompanyWebsite}
                                            name="website"
                                            value={this.state.website}
                                            onChange={this.onChange}
                                          />
                                          {errors.website && (
                                            <div className="invalid-feedback">
                                              {errors.website}
                                            </div>
                                          )}
                                        </div>
                                      )}
                                    </FormattedMessage>
                                  )}
                                </FormattedMessage>
                                <ReactTooltip place="right" multiline={true} />
                              </div>
                            )}
                            <div className="mx-auto">
                              <FormattedMessage id="createproduct.addnewproduct">
                                {(Addnewproduct) => (
                                  <button
                                    type="submit"
                                    className="btn btn-common mt-2"
                                    onClick={this.onClick}
                                    disabled={this.state.formSubmit}
                                  >
                                    {this.state.formSubmit && (
                                      <span
                                        className="spinner-border spinner-border-sm mr-2"
                                        role="status"
                                        aria-hidden="true"
                                        disabled={this.state.formSubmit}
                                      ></span>
                                    )}
                                    {Addnewproduct}
                                  </button>
                                )}
                              </FormattedMessage>
                            </div>
                          </div>
                        )}
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

CreateProduct.modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ['bold', 'italic', 'underline', 'blockquote'],
    [{ list: 'ordered' }, { list: 'bullet' }],
  ],
};

CreateProduct.formats = [
  'header',
  'bold',
  'italic',
  'underline',
  'blockquote',
  'list',
  'bullet',
];

CreateProduct.propTypes = {
  auth: PropTypes.object.isRequired,
  locale: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  product: PropTypes.object.isRequired,
  company: PropTypes.object.isRequired,
  info: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  product: state.product,
  company: state.company,
  errors: state.errors,
  info: state.info,
  locale: state.locale,
});

export default connect(mapStateToProps, {
  createProduct,
  getCurrentCompany,
  getInfosByPage,
})(withRouter(injectIntl(CreateProduct)));
